export default {
  TEXT: 'TEXT',
  TEXTWITHLINK: 'TEXT_WITH_LINK',
  ORDERDETAILS: 'ORDER_DETAILS',
  SUGGESTION: 'SUGGESTION',
  ORDERITEMS: 'ORDER_ITEMS',
  PIECHART: 'PIE_CHART',
  LINECHART: 'LINE_CHART',
  VBARCHART: 'V_BAR_CHART',
  HBARCHART: 'H_BAR_CHART'
};


// WEBPACK FOOTER //
// ./src/components/types.js